module.exports = __webpack_public_path__ + "static/media/chat.e2c729c5.png";